import React from "react";
import { Lock, ShieldAlert } from "lucide-react";

const labelStyles = {
  public: "bg-[#EEF2EE] text-[#36453A] border-[#B5C2B8]",
  internal: "bg-[#F4F1EA] text-[#5C5854] border-[#E6E2D8]",
  restricted: "bg-[#FFF1E5] text-[#B45B3E] border-[#C47F4B]",
  approval: "bg-[#FFF7E8] text-[#9B6716] border-[#D08C38]",
};

export function VisibilityBadge({ level, className = "", ...rest }) {
  const map = { public: "Public", internal: "Internal", restricted: "Restricted" };
  return (
    <span
      className={`inline-flex items-center gap-1 text-[10px] tracking-[0.18em] uppercase font-semibold px-2 py-0.5 rounded-sm border ${labelStyles[level] || labelStyles.internal} ${className}`}
      {...rest}
    >
      {level === "restricted" && <Lock className="w-3 h-3" strokeWidth={2} />}
      {map[level] || level}
    </span>
  );
}

export function CulturalApprovalBadge({ className = "" }) {
  return (
    <span className={`inline-flex items-center gap-1 text-[10px] tracking-[0.18em] uppercase font-semibold px-2 py-0.5 rounded-sm border ${labelStyles.approval} ${className}`}>
      <ShieldAlert className="w-3 h-3" strokeWidth={2} />
      Cultural authority approval required
    </span>
  );
}

const permissionStyles = {
  approved: "bg-[#EEF2EE] text-[#36453A] border-[#B5C2B8]",
  in_review: "bg-[#FFF7E8] text-[#9B6716] border-[#D08C38]",
  pending: "bg-[#F4F1EA] text-[#5C5854] border-[#E6E2D8]",
  conditional: "bg-[#FFF7E8] text-[#9B6716] border-[#D08C38]",
  denied: "bg-[#FFF1E5] text-[#B45B3E] border-[#C47F4B]",
};

export function PermissionStatusBadge({ status, ...rest }) {
  if (!status) return <span className="text-xs text-[#8A857D]">—</span>;
  const display = status.replace(/_/g, " ");
  return (
    <span
      className={`inline-flex items-center text-[10px] tracking-[0.16em] uppercase font-semibold px-2 py-0.5 rounded-sm border ${permissionStyles[status] || permissionStyles.pending}`}
      {...rest}
    >
      {display}
    </span>
  );
}

export function ClimateRiskBadge({ score }) {
  if (score == null) return <span className="text-xs text-[#8A857D]">—</span>;
  let cls = "bg-[#EEF2EE] text-[#36453A] border-[#B5C2B8]";
  let label = "Low";
  if (score >= 7) { cls = "bg-[#FFF1E5] text-[#B45B3E] border-[#C47F4B]"; label = "High"; }
  else if (score >= 4) { cls = "bg-[#FFF7E8] text-[#9B6716] border-[#D08C38]"; label = "Moderate"; }
  return (
    <span className={`inline-flex items-center gap-1 text-[10px] tracking-[0.16em] uppercase font-semibold px-2 py-0.5 rounded-sm border ${cls}`}>
      {label} · {score}
    </span>
  );
}
